import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ApiService,
    FilterRequest,
    ListResponse,
    ResponseCode,
    SortDirectionEnterprise
} from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';

export enum PaymentMethodType {
    ACH,
    WIRE
}

export enum AutoVerifyStatus {
    CLOSED = 'CLOSED',
    OPEN = 'OPEN',
    UNKNOWN = 'UNKNOWN',
    ERROR = 'ERROR',
    UNCHECKED = 'UNCHECKED'
}

export enum PaymentMethodStatus {
    UNREGISTERED = 'UNREGISTERED',
    IN_REVIEW = 'IN_REVIEW',
    VERIFIED = 'VERIFIED',
    REJECTED = 'REJECTED'
}

export class SupplierPaymentMethodQueryRow {
    public paymentMethodKey: string;
    public accountName: string;
    public accountNumber: string;
    public paymentMethodType: PaymentMethodType;
    public autoVerifyStatus: AutoVerifyStatus;
    public paymentMethodStatus: PaymentMethodStatus;
    public validationResponse: string;
    public default: boolean;
    constructor(obj?: {
        paymentMethodKey: string;
        accountName: string;
        accountNumber: string;
        paymentMethodType: PaymentMethodType;
        autoVerifyStatus: AutoVerifyStatus;
        paymentMethodStatus: PaymentMethodStatus;
        validationResponse: string;
        default: boolean;
    }) {
        if (obj != null) {
            this.paymentMethodKey =
                typeof obj.paymentMethodKey === 'undefined'
                    ? this.paymentMethodKey
                    : obj.paymentMethodKey;
            this.accountName =
                typeof obj.accountName === 'undefined' ? this.accountName : obj.accountName;
            this.accountNumber =
                typeof obj.accountNumber === 'undefined' ? this.accountNumber : obj.accountNumber;
            this.paymentMethodType =
                typeof obj.paymentMethodType === 'undefined'
                    ? this.paymentMethodType
                    : obj.paymentMethodType;
            this.paymentMethodStatus =
                typeof obj.paymentMethodStatus === 'undefined'
                    ? this.paymentMethodStatus
                    : obj.paymentMethodStatus;
            this.default = typeof obj.default === 'undefined' ? this.default : obj.default;
            this.autoVerifyStatus =
                typeof obj.autoVerifyStatus === 'undefined'
                    ? this.autoVerifyStatus
                    : obj.autoVerifyStatus;
            this.validationResponse =
                typeof obj.validationResponse === 'undefined'
                    ? this.validationResponse
                    : obj.validationResponse;
        }
    }
}

export class ListSupplierPaymentMethodsRequest extends FilterRequest {
    supplierKey: string;
    constructor(obj?: {
        skip?: number;
        take?: number;
        sortColumn?: string;
        sortDirection?: SortDirectionEnterprise;
        supplierKey?: string;
    }) {
        super(obj);
        if (obj != null) {
            this.supplierKey =
                typeof obj.supplierKey === 'undefined' ? this.supplierKey : obj.supplierKey;
        }
    }
}

export class ListSupplierPaymentMethodsResponse extends ListResponse<
    SupplierPaymentMethodQueryRow
> {
    constructor(obj?: {
        code?: ResponseCode;
        message?: string;
        totalCount?: number;
        skip?: number;
        take?: number;
        sortColumn?: string;
        sortDirection?: SortDirectionEnterprise;
        rows?: SupplierPaymentMethodQueryRow[];
    }) {
        super(obj);
    }
}

@Injectable({ providedIn: 'root' })
export class ListSupplierPaymentMethodsService extends ApiService<
    ListSupplierPaymentMethodsRequest,
    ListSupplierPaymentMethodsResponse
> {
    public requestType = ListSupplierPaymentMethodsRequest;
    public responseType = ListSupplierPaymentMethodsResponse;
    public endpointName = 'operations/ListSupplierPaymentMethods';
    public serviceName = 'financing';
    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }
}
